import React from 'react';
export function MethodSection() {
  const pillars = [{
    number: '1',
    title: 'Desinchar',
    text: 'Reduzir alimentos que favorecem retenção, gases e sensação de peso.'
  }, {
    number: '2',
    title: 'Destravar',
    text: 'Organizar horários, combinações e escolhas alimentares para ajudar a digestão e o intestino.'
  }, {
    number: '3',
    title: 'Dar Continuidade',
    text: 'Criar uma rotina leve o suficiente para você conseguir manter sem sofrimento.'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-170">
      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-171">
        <div className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-4" data-id="element-173">
            O Método Cintura Leve 3D
          </h2>
          <h3 className="text-xl text-brand-sage-dark font-medium" data-id="element-174">
            O Desincha40+ usa uma sequência simples baseada em três pilares.
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-175">
          {pillars.map((pillar, index) => <div key={index} className="bg-brand-cream p-8 rounded-3xl border border-brand-sage/40 shadow-sm relative pt-12" data-id="element-176">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-brand-dark text-white rounded-full flex items-center justify-center text-2xl font-serif font-bold shadow-md" data-id="element-177">
                {pillar.number}
              </div>
              <h4 className="text-2xl font-serif font-bold text-brand-dark mb-4 text-center" data-id="element-178">
                {pillar.number}. {pillar.title}
              </h4>
              <p className="text-brand-text/80 text-center leading-relaxed" data-id="element-179">
                {pillar.text}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-beige p-6 md:p-8 rounded-2xl text-center border border-brand-sage/30" data-id="element-180">
          <p className="text-xl md:text-2xl font-serif font-medium text-brand-dark italic" data-id="element-181">
            "O segredo não é fazer algo perfeito por 3 dias. É fazer algo
            possível por tempo suficiente para o corpo responder."
          </p>
        </div>
      </div>
    </section>;
}